var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.36,
    height: 16,
    viewBox: "0 0 15.36 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10625",
    "data-name": "Path 10625",
    d: "M811.64,4.065h-.16a.161.161,0,0,0,.16-.16v.16h6.079V3.9a.161.161,0,0,0,.16.16h-.16v1.44h1.44V3.9a1.281,1.281,0,0,0-1.28-1.28h-6.4A1.281,1.281,0,0,0,810.2,3.9v1.6h1.44Zm10.08,1.44H807.64a.639.639,0,0,0-.64.64v.64a.16.16,0,0,0,.16.16h1.208l.494,10.46a1.281,1.281,0,0,0,1.278,1.22h9.079A1.279,1.279,0,0,0,820.5,17.4l.494-10.46H822.2a.16.16,0,0,0,.16-.16v-.64A.639.639,0,0,0,821.72,5.505Zm-2.654,11.68h-8.772l-.484-10.24h9.74Z",
    transform: "translate(-807 -2.625)",
    fill: "#33af89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGreen);
export default __webpack_public_path__ + "static/media/delete-green.cfe377cb5eca49d9845d6bdb5d6e2073.svg";
export { ForwardRef as ReactComponent };